import React, { useState, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import {
  FormattedMessage,
} from 'react-intl'

import ModalPinCode from './ModalPinCode'
import HandCrushedDefault from '../Graphics/HandCrushed'
import styles from '../../../../css/devicePage.module.css'
import notificationStyles from '../../../../css/notifications.module.css'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

Modal.setAppElement('#app')

const normalModalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(196, 196, 196, 0.8)',
    zIndex: 100,
  },
  content: {
    top: '50%',
    left: '50%',
    maxWidth: '80%',
    width: '300px',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    borderRadius: '10px',
    boxShadow: 'none',
    border: 'none',
    transform: 'translate(-50%, -50%)',
  },
}
const warningModalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(196, 196, 196, 0.8)',
    zIndex: 100,
  },
  content: {
    top: '50%',
    left: '50%',
    maxWidth: '80%',
    width: '300px',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    borderRadius: '10px',
    boxShadow: 'none',
    border: 'none',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#d00000',
    color: '#fff',
  },
}

const ModalSetBool2 = ({
  textLeft,
  textRight,
  textSub,
  textModal,
  textSave,
  tileColorLeft,
  tileColorRight,
  settingName,
  settingCurrentValue,
  settingNewValue,
  address,
  warning,
  warningText,
  enable,
  pinCode,
  customer,
  name,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [warningModalIsOpen, setWarningModalIsOpen] = useState(false)

  useEffect(() => {
    if (pinCode.cancelled === true) {
      cancelChange()
    }
  }, [pinCode.cancelled])

  const openModal = useCallback(() => {
    closeWarningModal()
    if (enable) {
      setModalIsOpen(true)
    }
  }, [enable])

  const openWarningModal = useCallback(() => {
    closeModal()
    setWarningModalIsOpen(true)
  }, [])

  const afterOpenModal = useCallback(() => {
    const newSetting = {
      address,
      settings: {},
      status: 'new',
    }
    newSetting.settings[settingName] = settingNewValue
    AppDispatcher.dispatch({
      action: 'change-setting',
      setting: newSetting,
    })
  }, [address, settingName, settingNewValue])

  const afterOpenWarningModal = useCallback(() => {
  }, [])

  const saveSetting = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'save-settings',
    })
    closeModal()
    closeWarningModal()
    AppDispatcher.dispatch({
      action: 'pin-code-unload',
    })
  }, [])

  const whichModal = useCallback(() => {
    if (warning) {
      openWarningModal()
    } else {
      saveSetting()
    }
  }, [warning, openWarningModal, saveSetting])

  const cancelChange = useCallback(() => {
    closeModal(() => {
      closeWarningModal(() => {
        AppDispatcher.dispatch({
          action: 'pin-code-unload',
        })
      })
    })
  }, [])

  const closeModal = useCallback((callback) => {
    setModalIsOpen(false)
    if (callback && typeof callback === 'function') {
      callback()
    }
  }, [])

  const closeWarningModal = useCallback((callback) => {
    setWarningModalIsOpen(false)
    if (callback && typeof callback === 'function') {
      callback()
    }
  }, [])

  const {
    security,
  } = customer || {}

  let pinRequired = false
  if (security && typeof security === 'object') {
    pinRequired = security.pin
  }

  return (
    <div>
      <button
        type='button'
        name={name}
        onClick={openModal}
        className={`${styles.controlButton}`}
      >
        <div
          className={`${settingCurrentValue ? styles.controlButtonInactive : styles.controlButtonActive} ${styles.tile} ${styles.controlButtonLeft} ${tileColorLeft || 'normal'}`}
        >
          <h2 className={styles.tileValue}>{textLeft}</h2>
          <h6>{textSub}</h6>
        </div>
        <div
          className={`${settingCurrentValue ? styles.controlButtonActive : styles.controlButtonInactive} ${styles.tile} ${styles.controlButtonRight} ${tileColorRight || 'normal'}`}
        >
          <h2 className={styles.tileValue}>{textRight}</h2>
          <h6>&nbsp;</h6>
        </div>
      </button>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={normalModalStyle}
        contentLabel={`${settingName}_confirmation`}
      >
        <ModalPinCode
          required={pinRequired}
          status={pinCode.status}
          pageChange={false}
        />
        <h4 className={notificationStyles.modalHead}>{textModal}</h4>
        <h3 className={notificationStyles.modalSave}>
          <button
            type='button'
            className={notificationStyles.modalSaveButton}
            onClick={whichModal}
          >
            {textSave}
          </button>
          <button onClick={cancelChange} type='button'>CANCEL</button>
        </h3>
      </Modal>
      <Modal
        isOpen={warningModalIsOpen}
        onAfterOpen={afterOpenWarningModal}
        onRequestClose={closeWarningModal}
        style={warningModalStyle}
        contentLabel={`${settingName}_warning`}
      >
        <h3 className={`${notificationStyles.modalHead} ${notificationStyles.modalHeadNoMargin}`}>
          <FormattedMessage
            id='headline.warning'
            defaultMessage='WARNING: '
            description='WARNING: label'
          />
        </h3>
        <div className={styles.warningGraphic}>
          <HandCrushedDefault />
        </div>
        <h5 className={notificationStyles.modalHeadWarning}>{warningText}</h5>
        <h3 className={notificationStyles.modalSave}>
          <button
            type='button'
            className={notificationStyles.modalSaveButtonWarning}
            onClick={saveSetting}
          >
            OK
          </button>
          <button
            type='button'
            className={notificationStyles.modalSaveButton}
            onClick={cancelChange}
          >
            NO
          </button>
        </h3>
      </Modal>
    </div>
  )
}

ModalSetBool2.propTypes = {
  textLeft: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  textRight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  textSub: PropTypes.any,
  textModal: PropTypes.any,
  textSave: PropTypes.any,
  tileColorLeft: PropTypes.string,
  tileColorRight: PropTypes.string,
  settingName: PropTypes.string,
  settingCurrentValue: PropTypes.number,
  settingNewValue: PropTypes.number,
  address: PropTypes.string,
  warning: PropTypes.bool,
  warningText: PropTypes.any,
  enable: PropTypes.bool,
  pinCode: PropTypes.object,
  customer: PropTypes.object,
  name: PropTypes.string,
}

export default ModalSetBool2
